const app = require(`./appConfig.${process.env.NODE_ENV || 'production'}.json`);
const config = {
  app
}

module.exports = config;